import React from 'react';
import { Link } from 'react-router-dom';
import './TermsAndConditions.css';

/**
 * Placeholder Premium Subscription Terms.
 * Replace content with lawyer-drafted terms when ready.
 */
export default function PremiumTerms() {
  return (
    <div className="terms-container">
      <div className="terms-content">
        <div className="terms-header">
          <h1>Premium Subscription Terms</h1>
          <p className="last-updated">Last updated: {new Date().toLocaleDateString()}</p>
        </div>

        <div className="terms-body">
          <section className="terms-section">
            <h2>1. Scope</h2>
            <p>
              These terms apply to premium subscriptions for WhatToMake.co.za. By subscribing, you agree to these terms in addition to our general Terms and Conditions.
            </p>
          </section>

          <section className="terms-section">
            <h2>2. Payment</h2>
            <p>
              All payments are <strong>one-time charges</strong> in South African Rand (ZAR) processed securely via PayFast. You are charged once for the chosen access period (1 month or 12 months). There is no automatic renewal — your account returns to the free tier when the access period expires.
            </p>
          </section>

          <section className="terms-section">
            <h2>3. Refunds</h2>
            <p>
              Because there is no recurring billing you do not need to cancel. Refund requests will be considered on a case-by-case basis and must be submitted within 7 days of payment. Full refund policy will be set out in the final terms provided by our legal advisors.
            </p>
          </section>

          <section className="terms-section">
            <h2>4. Placeholder</h2>
            <p>
              This document is a placeholder. Full Premium Subscription Terms will be added once finalised by legal counsel. For questions in the meantime, contact us at higgos@whattomake.co.za.
            </p>
          </section>
        </div>

        <div className="terms-footer">
          <Link to="/premium" className="back-to-register">← Back to Premium</Link>
        </div>
      </div>
    </div>
  );
}
